.screen {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
.rings {
  position: relative;
  width: 220px;
  height: 220px;
  animation: evx-fadeUp 1s ease 0.3s both;
}
.ringOuter,
.ringInner {
  transform-origin: 50% 50%;
}
.ringOuter {
  stroke: var(--color-accent-200);
  animation: evx-spin 26s linear infinite;
}
.ringInner {
  stroke: var(--color-neutral-300);
  animation: evx-spinr 20s linear infinite;
}
.brand {
  /* Overlaps the rings; keep the wordmark painted above them. */
  position: relative;
  z-index: 1;
  text-align: center;
  margin-top: -190px;
}
.kicker {
  font-size: 12px;
  letter-spacing: 0.24em;
  color: var(--color-accent-700);
  font-weight: 700;
  animation: evx-reveal 0.6s ease 0.5s both;
}
.wordmark {
  margin: 0;
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 88px;
  letter-spacing: 0.04em;
  line-height: 1.1;
  color: var(--color-text);
  animation: evx-track 1.2s cubic-bezier(0.2, 0.7, 0.2, 1) 0.6s both;
}
.version {
  font-size: 13px;
  color: var(--color-neutral-700);
  font-weight: 600;
  animation: evx-reveal 0.8s ease 1.3s both;
}
.progress {
  position: relative;
  width: 420px;
  height: 6px;
  overflow: hidden;
  background: var(--color-neutral-200);
  border-radius: 99px;
  animation: evx-fadeUp 0.5s ease 1.5s both;
}
.progressFill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: var(--color-accent);
  border-radius: 99px;
  transition: width 0.1s linear;
}
.checks {
  width: 460px;
  animation: evx-fadeUp 0.5s ease 1.6s both;
}
